<form #form="ngForm">
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label>{{ 'reporting.reports.selectDateRange' | translate }}</mat-label>
            <mat-date-range-input [rangePicker]="picker">
                <input
                    matStartDate
                    name="startDate"
                    #startDateInput="ngModel"
                    required
                    [(ngModel)]="startDate"
                    placeholder="{{ 'reporting.reports.startDate' | translate }}"
                />
                <input
                    matEndDate
                    name="endDate"
                    #endDateInput="ngModel"
                    required
                    [(ngModel)]="endDate"
                    placeholder="{{ 'reporting.reports.endDate' | translate }}"
                />
            </mat-date-range-input>
            <mat-date-range-picker #picker></mat-date-range-picker>
            <mat-datepicker-toggle matSuffix [for]="picker">
                <mat-icon matDatepickerToggleIcon svgIcon="calendar"></mat-icon>
            </mat-datepicker-toggle>
            <mat-error *ngIf="startDateInput.invalid && startDateInput.touched">{{
                startDateInput.errors | formErrors
            }}</mat-error>
            <mat-error *ngIf="endDateInput.invalid && endDateInput.touched">{{
                endDateInput.errors | formErrors
            }}</mat-error>
        </mat-form-field>
    </div>
    <!--    Positions-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectPositions' | translate }}</mat-label>
            <mat-select
                name="positionField"
                [(ngModel)]="selectedJobIds"
                placeholder="{{ 'reporting.reports.allPositions' | translate }}"
                multiple
            >
                <mat-option *ngFor="let job of jobs" [value]="job.id">{{ job.title }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--Department-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectDepartments' | translate }}</mat-label>
            <mat-select
                name="departmentField"
                [(ngModel)]="selectedDepartmentIds"
                placeholder="{{ 'reporting.reports.allDepartments' | translate }}"
                multiple
            >
                <mat-option *ngFor="let department of departments" [value]="department.id">{{
                    department.name
                }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
    <!--Projects-->
    <div class="app-grid">
        <mat-form-field class="columns-12">
            <mat-label appRemoveAriaOwns>{{ 'reporting.reports.selectProjects' | translate }}</mat-label>
            <mat-select
                name="projectField"
                [(ngModel)]="selectedProjectIds"
                placeholder="{{ 'reporting.reports.allProjects' | translate }}"
                multiple
            >
                <mat-option *ngFor="let project of projects" [value]="project.id">{{ project.name }}</mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</form>
